/* no babel so we have to use old js syntax */
window.Popper = require('popper.js');
require('bootstrap');

import "@fontsource/open-sans/latin.css";
import "@fontsource/pathway-gothic-one/latin.css";

;$(function() {
  var $hamburger = $(".hamburger");
  $hamburger.on("click", function (e) {
    $hamburger.toggleClass("is-active");
    document.querySelector('body>header').classList.toggle('h-auto')
  });
});



//////////////////
// WEBPACK FOOTER
// ./js/theme.js
// module id = 2
// module chunks = 0